import React from "react";
import PropTypes from "prop-types";
import { Box, Button, Card, CardActions, CardContent, CardMedia, Typography, Grid } from "../../imports/muiImport";
import { Link, titleToUrl, defaultProductImage } from "../../imports/generalImport";
import "./productStyle.css";
import { isDiscountedProduct } from "../../hooks/utilsFn/utilsFn";

const defaultStyles = {
  // width: {
  //   xs: "170px",
  //   sm: "195px",
  //   md: "180px ",
  //   lg: "185px",
  //   xl: "200px",
  // },
  // height: {
  //   xs: "190px",
  //   sm: "266px",
  //   md: "247px",
  //   lg: "260px",
  //   xl: "255px",
  // },
  width: {
    xs: "170px",
    sm: "195px",
    md: "180px ",
    lg: "185px",
    xl: "200px",
  },
  height: {
    xs: "190px",
    sm: "266px",
    md: "247px",
    lg: "240px",
    xl: "240px",
  },
  borderRadius: {
    xs: 6,
    sm: 4,
    lg: 4
  },
  border: {
    xs: 0,
    sm: "3px solid #deebff"
  },
  mx: { xs: "3px", sm: 1 },
  my: {
    xs: "5px",
    sm: "3px",
    lg: "5px",
  },
  mb: {
    xs: "10px",
    sm: "3px",
    lg: "5px",
  },
  "&:hover": {
    boxShadow: {
      sm: 3,
    },
    border: {
      xs: 0,
      sm: "3px solid #deebff"
    },
    // backgroundColor: "#dee5eb"
  },
  cardMedia: {
    p: 0,
    width: "100%",
    minHeight: { xs: 113, sm: 120, md: 100, lg: 115, xl: 115 },
    maxHeight: { xs: 151, sm: 122, md: 100, lg: 116, xl: 116 },
    borderRadius: "0 0 10px 10px",
    objectFit: {
      xs: "fill",
      sm: "cover",
      lg: "cover"
    },
    backgroundSize: {
      xs: "fill",
      sm: "cover",
      lg: "cover"
    },
    objectPosition: "50% 50%",
    mixBlendMode: "multiply"
  },
  ".product__discount": {
    backgroundRepeat: "no-repeat",
    objectFit: "auto",
    width: 150,
    // border: 3,
    // borderColor:"#000"
  },
  boughtUser: {
    fontSize: {
      xs: "10px",
      lg: "10px"
    },
    color: {
      xs: "textPrimary.main",
      lg: "textPrimary.main"
    },
    fontWeight: {
      xs: 400,
      lg: 400
    },
    display: {
      xs: "none",
      sm: "block"
    }
  },
  cardContent: {
    mt: 3,
    py: { xs: 0 },
    px: { xs: "10px", sm: "15px" },
    height: { xs: "max-content", sm: "80px", md: "80px", lg: "45px" },
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 2,
    textAlign: { xs: "center", sm: "left", lg: "center" },
    mb: "5px",
  },
  title: {
    color: {
      xs: "primary.main",
      sm: "primary.main",
      lg: "primary.main"
    },
    fontSize: {
      xs: "14px",
      sm: ".9rem",
      md: ".9rem",
      lg: "1.2rem",
      xl: "14px",
    },
    fontWeight: { xs: 500, sm: 500, lg: 500, xl: 500 },
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
    WebkitLineClamp: 2,
    maxHeight: "3.6rem",
    lineHeight: { xs: "24px", md: "22px" },
    overflowWrap: "break-word",
    wordBreak: "normal",
  },
  button: {
    width: "100%",
    fontSize: {
      xs: "9px",
      sm: "10px",
      lg: "12px"
    },
    color: {
      xs: "white.main",
      sm: "white.main",
    },
    backgroundColor: {
      xs: "primary.main",
      sm: "primary.main",
    },
    textTransform: {
      xs: "capitalize"
    },
    borderRadius: {
      xs: 5,
      sm: 5,
      lg: 1
    }
  },
  cardActions: {
    px: 2,
    display: {
      xs: "none",
      sm: "flex"
    },
    flexDirection: "column",
    alignItems: "flex-start",
    py: 0,
  },
};

const ProductCard = ({ customStyles, data }) => {
  const mergedStyles = { ...defaultStyles, ...customStyles };
  const {productType, discount} = isDiscountedProduct(data?.discount, data?.cashback_amount);

  return (
    <Link
      to={`/card-details/${data?.id}/${titleToUrl(data?.title)}`}
      style={{
        textDecoration: "none",
      }}
    >
      <Card className="product__card" sx={mergedStyles}>
        <CardMedia
          className="product__cardmedia"
          sx={{ ...mergedStyles.cardMedia, position: "relative" }}
          image={data?.image ? data?.image : defaultProductImage}
          alt={data?.title ? data?.title : "default product image"}
          loading="lazy"
        >

          <Box
            className="product__discount"
            sx={{
              textAlign: "center",
              py:2,
            }}
          >
            <Typography
              variant="subtitle1"
              component="div"
              sx={{
                color: "#fff",
                fontWeight: 400,
                fontSize: 12,
                px:"2px",
              }}
            >
              {`${productType}`} :
              <Typography
                variant="subtitle1"
                component="span"
                sx={{
                  color: "white.main",
                  fontWeight: 400,
                  fontSize: 12,   
                  ml:"3px"
                }}
              >
                {`${discount}%`}
              </Typography>
            </Typography>
          </Box>
        </CardMedia>

        <CardContent sx={mergedStyles.cardContent}>
          <Typography
            variant="subtitle1"
            sx={mergedStyles.title}
          >
            {data?.title}
          </Typography>
        </CardContent>

        <CardActions sx={mergedStyles.cardActions}>
          <Button
            variant="contained"
            size="large"
            sx={mergedStyles.button}
            className="product__purchase_button"
          >
            Purchase Now
          </Button>
        </CardActions>
      </Card>

    </Link>
  );
};

ProductCard.propTypes = {
  customStyles: PropTypes.object,
};

export default ProductCard;
